const NoAnomalyFound = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="171"
      height="113"
      viewBox="0 0 171 113"
      fill="none"
    >
      <path
        d="M55.9923 112.49H1C1 97.3519 13.305 85.0898 28.4962 85.0898C35.5809 85.0898 42.0317 87.7503 46.9015 92.1349C52.4872 97.1438 55.9923 104.412 55.9923 112.49Z"
        fill="#E8E8E8"
        stroke="#1C1C1C"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M138.311 112.49H83.3184C83.3184 97.3519 95.6234 85.0898 110.815 85.0898C117.899 85.0898 124.35 87.7503 129.22 92.1349C134.806 97.1438 138.311 104.412 138.311 112.49Z"
        fill="#E8E8E8"
        stroke="#1C1C1C"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M110.815 78.871C118.797 78.871 125.267 72.4229 125.267 64.4687C125.267 56.5145 118.797 50.0664 110.815 50.0664C102.833 50.0664 96.3618 56.5145 96.3618 64.4687C96.3618 72.4229 102.833 78.871 110.815 78.871Z"
        fill="#E8E8E8"
        stroke="#1C1C1C"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.4962 78.871C36.4783 78.871 42.949 72.4229 42.949 64.4687C42.949 56.5145 36.4783 50.0664 28.4962 50.0664C20.5141 50.0664 14.0434 56.5145 14.0434 64.4687C14.0434 72.4229 20.5141 78.871 28.4962 78.871Z"
        fill="#E8E8E8"
        stroke="#1C1C1C"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.8"
        d="M63.4136 111.76H30.5882C33.1324 101.05 41.1897 92.0222 52.1639 86.9754C58.9719 93.1395 63.2719 101.956 63.4136 111.76Z"
        fill="#1C1C1C"
        stroke="#1C1C1C"
      />
      <path
        d="M69.1156 72.4338C78.5472 72.4338 86.193 64.8147 86.193 55.4161C86.193 46.0175 78.5472 38.3984 69.1156 38.3984C59.684 38.3984 52.0382 46.0175 52.0382 55.4161C52.0382 64.8147 59.684 72.4338 69.1156 72.4338Z"
        fill="white"
        stroke="#1C1C1C"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.6264 112.5C36.6264 94.6127 51.1748 80.1152 69.1245 80.1152C87.0743 80.1152 101.623 94.6127 101.623 112.5H36.6264Z"
        fill="white"
        stroke="#1C1C1C"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M125.472 44.7819L122.547 50.293L134.502 56.5954L137.428 51.0843L125.472 44.7819Z"
        fill="#E8E8E8"
        stroke="#1C1C1C"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M134.022 55.511L131.328 54.0904L133.563 49.8798L136.258 51.3005L134.022 55.511Z"
        fill="#1C1C1C"
        stroke="#1C1C1C"
      />
      <path
        d="M120.849 46.8282L120.849 46.8282C127.866 33.6106 122.804 17.2299 109.547 10.2381L109.547 10.238C96.2848 3.24646 79.8476 8.29635 72.831 21.5067L72.831 21.5067C65.8141 34.7243 70.8761 51.105 84.1391 58.0969L84.1392 58.0969C97.4016 65.0816 113.832 60.0386 120.849 46.8282ZM67.9811 18.95C76.4137 3.06486 96.1731 -2.99635 112.115 5.40736C128.057 13.8107 134.138 33.5002 125.705 49.3849C117.273 65.27 97.5133 71.3312 81.5713 62.9275C65.6299 54.5242 59.5487 34.8347 67.9811 18.95Z"
        fill="#1C1C1C"
        stroke="#1C1C1C"
        strokeWidth="0.5"
      />
      <path
        d="M122.379 45.8386C115.427 58.9269 99.1479 63.9241 86.007 57.0033C72.866 50.0758 67.8512 33.8466 74.803 20.7515C81.7549 7.66325 98.041 2.65929 111.182 9.58681C124.316 16.5143 129.331 32.7436 122.379 45.8386Z"
        fill="white"
        fillOpacity="0.5"
      />
      <path
        d="M113.983 4.31316C97.92 -4.15455 78.0095 1.95242 69.512 17.9597C61.0146 33.967 67.143 53.8079 83.2065 62.2756C99.2699 70.7434 119.18 64.6364 127.678 48.6291C136.175 32.6218 130.047 12.7809 113.983 4.31316ZM122.38 45.8379C115.428 58.9262 99.1484 63.9235 86.0074 57.0027C72.8665 50.0751 67.8517 33.8459 74.8035 20.7509C81.7553 7.66258 98.0415 2.65863 111.182 9.58614C124.317 16.5137 129.331 32.7429 122.38 45.8379Z"
        fill="#F7F7F7"
        stroke="#1C1C1C"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        width="15.72"
        height="37.4523"
        rx="7"
        transform="matrix(0.476388 -0.879235 0.880626 0.473811 130.53 60.1875)"
        fill="#0085FF"
        stroke="#1C1C1C"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoAnomalyFound;
